import Repo from './Repo.js'

export default class TravelWarrantRepository extends Repo {
  constructor () {
    super('travel-warrants')
  }

  all (q) {
      return super.all(q)
  }

  store (data) {
      return super.store(data)
  }

  update (id, data) {
      return super.update(id, data)
  }

  updateMy (id, data) {
    return this.http.post(this.resource + '/' + id + '/my/update', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  get (id, includes) {
      return super.get(id, includes)
  }

  delete (id) {
      return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }
  syncUsers(id, data){
    return this.http.post(this.resource + '/' + id + '/users/sync', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  exportTravelWarrant (id, name = "Putni nalog") {
    return this.http.download(this.resource + '/' + id + '/export').then((response) => {
      let blob = new Blob([response.data], { type:   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.xlsx';
      link.click();
      return Promise.resolve(response);
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchAndExport (data, name = "Izveštaj Putni nalozi") {
    data.export = 1;
    return this.http.download(this.resource + '/search', data).then((response) => {
      let blob = new Blob([response.data], { type:   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = name+'.xlsx';
    link.click();
    return Promise.resolve(response);
  }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
